<template>
  <div class="ai-assistant-page">
    <div class="container" ref="container">
      <!-- 顶部标题区域 -->
      <div class="header-section">
        <div class="header">
          <h1>软件开发和内容创作自动化平台</h1>
          <!-- 标题下方装饰线 -->
          <svg width="160" height="17" viewBox="0 0 160 17" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <rect width="160" height="17" fill="url(#pattern0_59086_3934)"/>
          <defs>
          <pattern id="pattern0_59086_3934" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_59086_3934" transform="scale(0.003125 0.0294118)"/>
          </pattern>
          <image id="image0_59086_3934" width="320" height="34" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
          </defs>
          </svg>
        </div>
        <!-- 小玩偶在标题右侧 -->
        <div class="mascot-avatar">
          <img src="@/assets/image/mascot.png" alt="mascot" />
        </div>
      </div>

      <!-- 搜索输入框 -->
      <div class="search-box-wrapper">
        <div class="search-box" ref="searchBox">
          <textarea
          ref="searchInput"
          v-model="searchText"
          :placeholder="currentPlaceholder"
          @keydown.enter.prevent="handleSend"
        ></textarea>
        <div class="search-toolbar">
          <div class="toolbar-left">
            <!-- 设置图标 -->
            <div class="toolbar-icon" title="设置">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
            </div>
            <!-- 联网搜索标签 -->
            <div class="search-tag" :class="{ active: networkSearchEnabled, inactive: !networkSearchEnabled }" @click="toggleNetworkSearch">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              联网搜索
            </div>
            <!-- OpenMe搜索标签 -->
            <div class="search-tag" :class="{ active: openMeSearchEnabled, inactive: !openMeSearchEnabled }" @click="toggleOpenMeSearch">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
              OpenMe搜索
            </div>
          </div>
          <div class="toolbar-right">
            <!-- 会话指示器 -->
            <div v-if="agentSessionCount > 0" class="session-indicator" @click="goToAgentSessions" title="查看智能体会话">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
              <span class="session-badge">{{ agentSessionCount }}</span>
            </div>
            <!-- 附件图标 -->
            <div class="toolbar-icon" title="附件">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.64 16.2a2 2 0 0 1-2.83-2.83l8.49-8.49"/>
              </svg>
            </div>
            <!-- 语音图标 -->
            <div class="toolbar-icon" title="语音">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                <line x1="12" y1="19" x2="12" y2="23"/>
                <line x1="8" y1="23" x2="16" y2="23"/>
              </svg>
            </div>
            <!-- 发送按钮 -->
            <button class="send-btn" @click="handleSend" title="发送">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      </div>

      <!-- 连线层 -->
      <div class="connection-lines">
        <svg>
          <path ref="path1" d="" class="connection-path" />
          <path ref="path2" d="" class="connection-path" />
        </svg>
      </div>

      <!-- 3D卡片轮播 -->
      <div class="carousel-container" ref="carouselContainer">
        <div class="carousel" ref="carousel"></div>
      </div>

      <!-- 底部内容展示 -->
      <div class="content-display">
        <div class="content-divider" ref="contentDivider"></div>
        <div class="content-header">
          <h2 class="content-title">{{ currentTitle }}</h2>
          <a href="#" class="view-more">{{ currentType === 'knowledge' ? '设置' : '查看更多' }} ></a>
        </div>
        <CreatorContent v-if="currentType === 'creator'" :search-text="filterText" :selected-agent-id="selectedAgentId" @select-agent="handleSelectAgent" />
        <AgentPlazaContent v-else-if="currentType === 'agent'" :search-text="filterText" :selected-agent-id="selectedAgentId" @select-agent="handleSelectAgent" />
        <IndustryContent v-else-if="currentType === 'industry'" :search-text="filterText" :selected-agent-id="selectedAgentId" @select-agent="handleSelectAgent" />
        <div v-else class="content-area" ref="contentArea"></div>
      </div>
    </div>
    
    <!-- 智能体任务执行面板 -->
    <div v-if="showTaskPanel" class="task-panel-overlay" @click.self="closeTaskPanel">
      <div class="task-panel">
        <div class="task-panel-header">
          <div class="task-info">
            <span class="task-agent-name">{{ selectedAgent?.name }}</span>
            <span class="task-status">{{ taskStatus }}</span>
          </div>
          <button class="close-btn" @click="closeTaskPanel">×</button>
        </div>
        <div class="task-panel-body">
          <iframe
            ref="taskIframe"
            :src="taskIframeUrl"
            class="task-iframe"
            frameborder="0"
            allowfullscreen
            allow="microphone; camera"
            @load="onTaskIframeLoad">
          </iframe>
          <div v-if="taskLoading" class="task-loading">
            <div class="loading-spinner"></div>
            <span>正在启动智能体...</span>
          </div>
        </div>
      </div>
    </div>
    
    <footer class="page-footer">
      <div class="footer-container">
        <div class="footer-brand">
          <div class="footer-logo" @click="handleLogoClick">
            <img src="/logo-128.png" alt="傻蛋AI" style="width: 40px; height: 40px;">
            <span>傻蛋AI</span>
          </div>
          <p class="footer-description">
            全球领先的AIGC企业协同创作平台<br>
            让每个企业拥有专属的AI创作军团
          </p>
        </div>

        <div class="footer-section">
          <h4>资源</h4>
          <ul class="footer-links">
            <li><a href="https://www.shadanai.com" target="_blank">官网</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>产品</h4>
          <ul class="footer-links">
            <li><a href="https://www.shadanai.com/#aigc" target="_blank">文本创作</a></li>
            <li><a href="https://www.shadanai.com/#aigc" target="_blank">图像生成</a></li>
            <li><a href="https://www.shadanai.com/#aigc" target="_blank">视频制作</a></li>
            <li><a href="https://www.shadanai.com/#agent" target="_blank">AI Agent</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>行业解决方案</h4>
          <ul class="footer-links">
            <li><a href="https://www.shadanai.com/solutions/restaurant-ai-marketing.html" target="_blank">餐饮行业AI营销</a></li>
            <li><a href="https://www.shadanai.com/solutions/ecommerce-ai-operation.html" target="_blank">电商AI自动化运营</a></li>
            <li><a href="https://www.shadanai.com/solutions/education-ai-content.html" target="_blank">教育AI内容制作</a></li>
            <li><a href="https://www.shadanai.com/solutions/finance-ai-compliance.html" target="_blank">金融AI合规文案</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>联系我们</h4>
          <ul class="footer-links">
            <li><a href="mailto:sales@shadan.ai">sales@shadan.ai</a></li>
            <li><a href="javascript:void(0)">添加微信咨询</a></li>
            <li><a href="javascript:void(0)">预约演示</a></li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; 2023 傻蛋AI ShadanAI. All rights reserved. | <a href="https://beian.miit.gov.cn/" target="_blank">辽ICP备15017423号-4</a></p>
      </div>
    </footer>

    <!-- OpenMe配置弹窗 -->
    <div v-if="showOpenMeConfig" class="modal-overlay" @click="cancelOpenMeConfig">
      <div class="modal-content" @click.stop>
        <h3>配置OpenMe搜索</h3>
        <div class="form-group">
          <label>OpenMe URL</label>
          <input v-model="openMeConfig.url" type="text" placeholder="https://openme.example.com" />
        </div>
        <div class="form-group">
          <label>API Key</label>
          <input v-model="openMeConfig.apiKey" type="password" placeholder="输入API Key" />
        </div>
        <div class="modal-actions">
          <button class="btn-cancel" @click="cancelOpenMeConfig">取消</button>
          <button class="btn-save" @click="saveOpenMeConfig">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreatorContent from '@/components/ai-assistant/CreatorContent.vue'
import AgentPlazaContent from '@/components/ai-assistant/AgentPlazaContent.vue'
import IndustryContent from '@/components/ai-assistant/IndustryContent.vue'
import { HappyIframeBridge } from '@/utils/HappyIframeBridge'
import { executeAgentTask } from '@/api/agentTaskApi'

export default {
  name: 'AIAssistantIndex',
  components: {
    CreatorContent,
    AgentPlazaContent,
    IndustryContent
  },
  data() {
    return {
      searchText: '',
      currentPlaceholder: '给我布置一个任务',
      currentTitle: '智能体广场',
      currentIndex: 0,
      currentType: 'agent',
      isAnimating: false,
      hasUserInteracted: false,
      autoPlayTimer: null,
      animationFrameId: null,
      radius: 380,
      networkSearchEnabled: true,
      openMeSearchEnabled: false,
      showOpenMeConfig: false,
      openMeConfig: {
        url: '',
        apiKey: ''
      },
      selectedAgent: null,
      showTaskPanel: false,
      taskLoading: false,
      taskStatus: '执行中',
      pendingTask: '',
      iframeBridge: null,
      agentSessionInfo: null,  // 智能体会话信息（已废弃）
      happySessionId: null,    // Happy 会话 ID
      iframeReady: false,      // iframe 是否就绪

      cardData: [
        { id: 'agent', title: '智能体广场', desc: '发现AI智能体', icon: '🤖', color: '#5B8FF9', placeholder: '选择一个智能体开始对话，或者描述你想要的AI助手...' },
        { id: 'creator', title: '超级个体', desc: '创作者与智能体', icon: '👤', color: '#6F5EF9', placeholder: '发现优秀创作者和他们的智能体...' },
        { id: 'industry', title: '行业智能体', desc: '360行业分类', icon: '🏢', color: '#FF9845', placeholder: '选择行业查看专业智能体...' },
        { id: 'chat', title: '聊天记录', desc: '历史对话记录', icon: '💬', color: '#5AD8A6', placeholder: '搜索历史对话记录，或继续之前的对话...' },
        { id: 'knowledge', title: 'OpenMe', desc: 'AI版微信知识库', icon: '📁', color: '#FF6B9D', placeholder: '搜索文件内容，或上传文档到工作区...' },
        { id: 'search', title: '联网搜索', desc: '实时网络搜索', icon: '🔍', color: '#F6BD16', placeholder: '输入你想搜索的内容，我会为你联网查找最新信息...' },
        { id: 'mcp', title: 'MCP工具', desc: '工具插件市场', icon: '🔧', color: '#5AD8A6', placeholder: '搜索工具插件，或描述你需要的功能...' },
        { id: 'code', title: '代码助手', desc: '编程辅助工具', icon: '💻', color: '#10A37F', placeholder: '描述你的编程需求，我会帮你编写代码...' }
      ],

      contentData: {
        agent: [
          { title: '智能客服助手', subtitle: '客户服务', desc: '专业的客户服务AI助手，7x24小时在线服务', tags: ['客服', '自动化'], icon: '👨‍💼', color: '#5B8FF9' },
          { title: '代码审查专家', subtitle: '开发工具', desc: '自动审查代码质量，提供优化建议', tags: ['编程', '代码'], icon: '👨‍💻', color: '#61DDAA' },
          { title: '数据分析师', subtitle: '数据分析', desc: '智能分析数据，生成可视化报表', tags: ['数据', '分析'], icon: '📊', color: '#F6BD16' },
          { title: '文案创作大师', subtitle: '内容创作', desc: '创作高质量营销文案和创意内容', tags: ['文案', '创意'], icon: '✍️', color: '#E86452' },
          { title: '项目管理助手', subtitle: '项目管理', desc: '协助项目规划和进度跟踪', tags: ['管理', '协作'], icon: '📋', color: '#6DC8EC' },
          { title: '翻译专家', subtitle: '语言翻译', desc: '支持100+语言的专业翻译', tags: ['翻译', '多语言'], icon: '🌐', color: '#9270CA' }
        ],
        chat: [
          { title: '如何优化React性能', desc: '讨论了React性能优化的最佳实践...', time: '今天 14:32', icon: '💬', color: '#5B8FF9' },
          { title: '数据库设计方案', desc: '探讨了电商系统的数据库架构设计...', time: '昨天 18:45', icon: '💬', color: '#61DDAA' },
          { title: 'UI设计规范讨论', desc: '确定了新版本的UI设计规范和组件库...', time: '2天前', icon: '💬', color: '#F6BD16' },
          { title: 'API接口文档', desc: '整理了后端API接口文档和调用示例...', time: '3天前', icon: '💬', color: '#E86452' }
        ],
        knowledge: [
          { title: 'README.md', size: '2.3 KB', source: '开发团队单聊', time: '今天 14:32', icon: '📄', color: '#4A90E2', type: 'markdown' },
          { title: 'package.json', size: '1.8 KB', source: '前端开发群', time: '今天 10:15', icon: '📦', color: '#F7DF1E', type: 'json' },
          { title: 'report.docx', size: '245 KB', source: '李四单聊', time: '2天前', icon: 'W', color: '#2B579A', type: 'word' },
          { title: 'data.xlsx', size: '89 KB', source: '数据分析群', time: '2天前', icon: 'X', color: '#217346', type: 'excel' },
          { title: 'presentation.pptx', size: '1.2 MB', source: '王五单聊', time: '3天前', icon: 'P', color: '#ED6C02', type: 'powerpoint' },
          { title: 'manual.pdf', size: '856 KB', source: '产品讨论群', time: '3天前', icon: 'PDF', color: '#E50914', type: 'pdf' }
        ],
        search: [
          { title: '2024年AI技术发展趋势', desc: '最新的人工智能技术动态和应用案例', time: '刚刚', icon: '🔥', color: '#FF6B9D' },
          { title: 'Vue 3.4版本更新内容', desc: 'Vue.js官方发布的最新版本特性', time: '10分钟前', icon: '📱', color: '#5B8FF9' },
          { title: 'OpenAI最新模型发布', desc: 'GPT-4 Turbo性能提升详解', time: '1小时前', icon: '🤖', color: '#5AD8A6' },
          { title: '前端性能优化最佳实践', desc: '2024年前端性能优化指南', time: '2小时前', icon: '⚡', color: '#F6BD16' },
          { title: 'TypeScript 5.3新特性', desc: 'TypeScript最新版本功能介绍', time: '今天 09:00', icon: '💎', color: '#6F5EF9' }
        ],
        mcp: [
          { title: 'GitHub集成', subtitle: '代码管理', desc: '自动管理代码仓库、PR和Issue', tags: ['开发', 'Git'], icon: '🔧', color: '#24292e' },
          { title: 'Jira连接器', subtitle: '项目管理', desc: '同步任务、管理工作流', tags: ['项目', '协作'], icon: '📋', color: '#0052CC' },
          { title: 'Notion集成', subtitle: '知识管理', desc: '读取和创建Notion文档', tags: ['文档', '笔记'], icon: '📝', color: '#000000' },
          { title: 'Slack机器人', subtitle: '团队协作', desc: '发送消息、管理频道', tags: ['通讯', '团队'], icon: '💬', color: '#4A154B' },
          { title: 'Google Drive', subtitle: '文件存储', desc: '访问和管理云端文件', tags: ['存储', '云端'], icon: '📁', color: '#4285F4' },
          { title: 'Figma插件', subtitle: '设计工具', desc: '读取设计稿、导出资源', tags: ['设计', 'UI'], icon: '🎨', color: '#F24E1E' }
        ],
        code: [
          { title: '代码生成', subtitle: '智能编码', desc: '根据需求自动生成代码', tags: ['生成', 'AI'], icon: '💻', color: '#10A37F' },
          { title: '代码优化', subtitle: '性能提升', desc: '优化代码性能和可读性', tags: ['优化', '重构'], icon: '🚀', color: '#5AD8A6' },
          { title: '错误调试', subtitle: '问题修复', desc: '快速定位和修复代码错误', tags: ['调试', '修复'], icon: '🐛', color: '#F6BD16' },
          { title: '单元测试', subtitle: '测试生成', desc: '自动生成单元测试代码', tags: ['测试', '质量'], icon: '✅', color: '#6F5EF9' },
          { title: '文档生成', subtitle: 'API文档', desc: '自动生成代码文档', tags: ['文档', '注释'], icon: '📚', color: '#FF9845' }
        ],
        image: [
          { title: 'DALL-E 3', subtitle: 'OpenAI', desc: '高质量图像生成模型', tags: ['绘画', '创意'], icon: '🎨', color: '#10A37F' },
          { title: 'Midjourney', subtitle: '艺术创作', desc: '艺术风格图像生成', tags: ['艺术', '风格化'], icon: '🖼️', color: '#FF6B9D' },
          { title: 'Stable Diffusion', subtitle: '开源模型', desc: '开源的图像生成模型', tags: ['开源', '自定义'], icon: '🎭', color: '#5B8FF9' },
          { title: 'Leonardo AI', subtitle: '游戏美术', desc: '游戏资产和角色设计', tags: ['游戏', '设计'], icon: '🎮', color: '#5AD8A6' },
          { title: 'Adobe Firefly', subtitle: 'Adobe', desc: '商业级AI图像生成', tags: ['商业', '版权'], icon: '✨', color: '#FF0000' },
          { title: '文心一格', subtitle: '百度', desc: '中文提示词优化的AI绘画', tags: ['中文', '本地'], icon: '🏮', color: '#2932E1' }
        ],
        industry: []
      }
    };
  },

  computed: {
    totalCards() {
      return this.cardData.length;
    },
    selectedAgentId() {
      return this.selectedAgent?.agentId || '';
    },
    agentPlaceholder() {
      if (this.selectedAgent) {
        return `请输入任务描述，开始执行「${this.selectedAgent.name}」智能体`;
      }
      return null;
    },
    filterText() {
      // 选中智能体后不再筛选，输入框用于任务描述
      return this.selectedAgent ? '' : this.searchText;
    },
    taskIframeUrl() {
      const baseUrl = process.env.NODE_ENV === 'development' 
        ? 'http://localhost:8081' 
        : 'https://happy.shadanai.com';
      return baseUrl;
    },
    agentSessionCount() {
      const chats = this.$store.state.chatStore?.chats || [];
      return chats.filter(c => c.type === 'AGENT').length;
    }
  },

  mounted() {
    this.contentData.industry = this.generateIndustryData();
    this.loadOpenMeConfig();
    this.initCards();
    this.updateContent();
    // 移除自动轮播
    // this.startAutoPlay();

    setTimeout(() => {
      this.drawLines();
      // 使用requestAnimationFrame实现60fps流畅更新
      this.startLineAnimation();
    }, 500);

    window.addEventListener('resize', this.drawLines);
  },

  beforeDestroy() {
    this.stopAutoPlay();
    this.stopLineAnimation();
    window.removeEventListener('resize', this.drawLines);
  },

  methods: {
    generateIndustryData() {
      const industries = [
        '互联网', '金融', '教育', '医疗', '零售', '制造', '房地产', '物流', '旅游', '餐饮',
        '农业', '能源', '交通', '通信', '媒体', '娱乐', '体育', '法律', '咨询', '广告',
        '建筑', '设计', '艺术', '文化', '出版', '影视', '音乐', '游戏', '电商', '社交',
        '搜索', '云计算', '大数据', '人工智能', '区块链', '物联网', '5G', '芯片', '软件', '硬件'
      ];
      
      const creators = ['张三', '李四', '王五', '赵六', '钱七', '孙八', '周九', '吴十'];
      const agentTypes = ['客服助手', '数据分析', '内容创作', '代码审查', '项目管理', '翻译专家', '设计助手', '营销顾问'];
      const colors = ['#5B8FF9', '#61DDAA', '#F6BD16', '#E86452', '#6DC8EC', '#9270CA', '#FF6B9D', '#10A37F'];
      const avatarColors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];
      
      const result = [];
      for (let i = 0; i < 360; i++) {
        const industry = industries[i % industries.length] + (i >= industries.length ? ` ${Math.floor(i / industries.length) + 1}` : '');
        const creator = creators[i % creators.length];
        const creatorAvatar = avatarColors[i % avatarColors.length];
        
        const agents = [];
        const agentCount = 3 + (i % 3);
        for (let j = 0; j < agentCount; j++) {
          agents.push({
            name: agentTypes[(i + j) % agentTypes.length],
            color: colors[(i + j) % colors.length]
          });
        }
        
        result.push({
          industry,
          creator,
          creatorAvatar,
          agents,
          color: colors[i % colors.length],
          icon: '🏢'
        });
      }
      return result;
    },

    initCards() {
      const carousel = this.$refs.carousel;
      if (!carousel) return;

      carousel.innerHTML = '';

      this.cardData.forEach((card, index) => {
        const cardElement = document.createElement('div');
        cardElement.className = 'card';
        cardElement.dataset.index = index;
        cardElement.dataset.type = card.id;

        cardElement.innerHTML = `
          <div class="card-icon" style="background: ${card.color}">
            ${card.icon}
          </div>
          <div class="card-title">${card.title}</div>
          <div class="card-desc">${card.desc}</div>
        `;

        cardElement.addEventListener('click', (e) => {
          e.stopPropagation();
          if (!this.hasUserInteracted) {
            this.hasUserInteracted = true;
            this.stopAutoPlay();
          }
          this.rotateToCard(index);
        });

        carousel.appendChild(cardElement);
      });

      this.updateCarousel(true);
    },

    updateCarousel(immediate = false) {
      const carousel = this.$refs.carousel;
      if (!carousel) return;

      const cardElements = carousel.querySelectorAll('.card');
      const angleStep = (2 * Math.PI) / this.totalCards;

      cardElements.forEach((card, index) => {
        const position = (index - this.currentIndex + this.totalCards) % this.totalCards;
        const angle = position * angleStep;

        const x = Math.sin(angle) * this.radius;
        const z = Math.cos(angle) * this.radius - this.radius;
        const rotateY = -angle * (180 / Math.PI);

        let distance = position;
        if (distance > this.totalCards / 2) {
          distance = this.totalCards - distance;
        }

        let opacity, scale;
        if (distance === 0) {
          opacity = 1;
          scale = 1.2;
        } else if (distance <= 1) {
          opacity = 0.85;
          scale = 0.95;
        } else if (distance <= 2) {
          opacity = 0.65;
          scale = 0.85;
        } else {
          opacity = 0.4;
          scale = 0.75;
        }

        if (immediate) {
          card.style.transition = 'none';
        }

        card.style.transform = `
          translateX(${x}px)
          translateZ(${z}px)
          rotateY(${rotateY}deg)
          scale(${scale})
        `;

        if (immediate) {
          setTimeout(() => {
            card.style.transition = '';
          }, 10);
        }

        card.style.opacity = opacity;
        card.style.zIndex = Math.round((1 - distance / this.totalCards) * 100) + 50;
        card.style.pointerEvents = 'all';

        if (position === 0) {
          card.classList.add('active');
          this.currentType = card.dataset.type;
        } else {
          card.classList.remove('active');
        }
      });

      this.$nextTick(() => {
        const currentCard = this.cardData.find(c => c.id === this.currentType);
        if (currentCard) {
          this.currentPlaceholder = this.agentPlaceholder || currentCard.placeholder;
          this.currentTitle = currentCard.title;
        }
        this.updateContent();
        this.drawLines();
      });
    },

    rotateToCard(targetIndex) {
      if (this.isAnimating || targetIndex === this.currentIndex) return;
      
      // 切换卡片时重置选中的智能体
      this.selectedAgent = null;

      let diff = targetIndex - this.currentIndex;

      if (Math.abs(diff) > this.totalCards / 2) {
        if (diff > 0) {
          diff = diff - this.totalCards;
        } else {
          diff = diff + this.totalCards;
        }
      }

      const steps = Math.abs(diff);
      const direction = diff > 0 ? 1 : -1;

      this.isAnimating = true;

      let currentStep = 0;
      const stepDuration = 180;

      const rotateStep = () => {
        currentStep++;
        this.currentIndex = (this.currentIndex + direction + this.totalCards) % this.totalCards;

        const isLastStep = currentStep >= steps;
        this.updateCarousel(false);

        if (isLastStep) {
          setTimeout(() => {
            this.isAnimating = false;
          }, 300);
        } else {
          setTimeout(rotateStep, stepDuration);
        }
      };

      rotateStep();
    },

    startAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        if (!this.hasUserInteracted) {
          this.currentIndex = (this.currentIndex + 1) % this.totalCards;
          this.updateCarousel(false);
        }
      }, 3000);
    },

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },

    startLineAnimation() {
      const animate = () => {
        this.drawLines();
        this.animationFrameId = requestAnimationFrame(animate);
      };
      animate();
    },

    stopLineAnimation() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },

    updateContent() {
      const contentArea = this.$refs.contentArea;
      if (!contentArea) return;

      const items = this.contentData[this.currentType] || [];

      if (this.currentType === 'creator' || this.currentType === 'agent' || this.currentType === 'industry') {
        // 使用组件渲染，无需在此处理
        return;
      } else if (this.currentType === 'knowledge') {
        contentArea.style.display = 'block';
        contentArea.innerHTML = `
          <div class="file-list">
            ${items.map(item => {
              const isOfficeFile = ['word', 'excel', 'powerpoint', 'pdf'].includes(item.type);
              const iconClass = isOfficeFile ? `office-icon ${item.type}` : '';
              
              return `
                <div class="file-item">
                  <div class="file-icon ${iconClass}" style="background: ${!isOfficeFile ? item.color : ''}">${item.icon}</div>
                  <div class="file-name">${item.title}</div>
                  <div class="file-size">${item.size}</div>
                  <div class="file-source">${item.source}</div>
                  <div class="file-time">${item.time}</div>
                </div>
              `;
            }).join('')}
          </div>
        `;
      } else {
        contentArea.style.display = 'grid';
        contentArea.innerHTML = items.map(item => `
          <div class="content-item">
            <div class="item-icon" style="background: ${item.color}">${item.icon}</div>
            <div class="item-details">
              <div class="item-title">${item.title}</div>
              <div class="item-desc">${item.subtitle || item.desc}</div>
            </div>
            ${item.tags ? `<div class="item-tags">${item.tags.map(tag => `<span class="tag">${tag}</span>`).join('')}</div>` : ''}
            ${item.time ? `<div class="item-time">${item.time}</div>` : ''}
          </div>
        `).join('');
      }
    },

    drawLines() {
      const searchBox = this.$refs.searchBox;
      const carousel = this.$refs.carousel;
      const contentDivider = this.$refs.contentDivider;
      const container = this.$refs.container;
      const path1 = this.$refs.path1;
      const path2 = this.$refs.path2;

      if (!searchBox || !carousel || !contentDivider || !container || !path1 || !path2) return;

      const activeCard = carousel.querySelector('.card.active');
      if (!activeCard) return;

      const searchBoxRect = searchBox.getBoundingClientRect();
      const activeCardRect = activeCard.getBoundingClientRect();
      const dividerRect = contentDivider.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      // 线1: 输入框到卡片
      const startCenterX1 = (searchBoxRect.left + searchBoxRect.right) / 2 - containerRect.left;
      const startBottom1 = searchBoxRect.bottom - containerRect.top;
      const endCenterX1 = (activeCardRect.left + activeCardRect.right) / 2 - containerRect.left;
      const endTop1 = activeCardRect.top - containerRect.top;

      // 添加手绘感的微小偏移
      const offsetX1 = Math.sin(Date.now() / 1000) * 3;
      const cp1x1 = startCenterX1 + offsetX1;
      const cp1y1 = startBottom1 + (endTop1 - startBottom1) * 0.3;
      const cp2x1 = endCenterX1 - offsetX1;
      const cp2y1 = startBottom1 + (endTop1 - startBottom1) * 0.7;

      path1.setAttribute('d', `M ${startCenterX1} ${startBottom1} C ${cp1x1} ${cp1y1}, ${cp2x1} ${cp2y1}, ${endCenterX1} ${endTop1}`);

      // 线2: 卡片到分割线
      const startCenterX2 = (activeCardRect.left + activeCardRect.right) / 2 - containerRect.left;
      const startBottom2 = activeCardRect.bottom - containerRect.top;
      const endCenterX2 = (dividerRect.left + dividerRect.right) / 2 - containerRect.left;
      const endTop2 = dividerRect.top - containerRect.top;

      // 相位相反的偏移
      const offsetX2 = Math.sin(Date.now() / 1000 + Math.PI) * 3;
      const cp1x2 = startCenterX2 + offsetX2;
      const cp1y2 = startBottom2 + (endTop2 - startBottom2) * 0.3;
      const cp2x2 = endCenterX2 - offsetX2;
      const cp2y2 = startBottom2 + (endTop2 - startBottom2) * 0.7;

      path2.setAttribute('d', `M ${startCenterX2} ${startBottom2} C ${cp1x2} ${cp1y2}, ${cp2x2} ${cp2y2}, ${endCenterX2} ${endTop2}`);
    },

    async handleSend() {
      if (!this.searchText.trim()) return;
      
      // 如果选中了智能体，执行智能体任务
      if (this.selectedAgent) {
        const taskContent = this.searchText.trim();
        this.searchText = '';
        
        try {
          this.pendingTask = taskContent;
          this.taskLoading = true;
          this.taskStatus = '正在创建会话...';
          this.showTaskPanel = true;
          
          // 1. 创建智能体会话
          const res = await this.$http.post('/agent/session/ensure', {
            agentId: this.selectedAgent.agentId,
            taskDescription: taskContent
          });
          console.log('[Index] 智能体会话创建成功');
          
          // 检查是否需要等待审批
          const sessionData = res;
          if (sessionData && (sessionData.status === 'PENDING_FRIEND' || sessionData.status === 'PENDING_GROUP')) {
            this.$message.info(sessionData.pendingMessage || '已发送申请，等待验证后即可使用');
            this.taskLoading = false;
            this.showTaskPanel = false;
            return;
          }
          // 2. 刷新智能体会话列表
          await this.$store.dispatch('loadAgentChatsFromServer');
          
          // 3. 等待会话出现在 chatStore 中
          let retries = 20;
          let agentChat = null;
          while (retries > 0) {
            agentChat = this.$store.state.chatStore.chats.find(c =>
              c.type === 'AGENT' && c.agentId === this.selectedAgent.agentId
            );
            if (agentChat) break;
            await new Promise(resolve => setTimeout(resolve, 500));
            retries--;
          }
          
          if (!agentChat) {
            throw new Error('创建智能体会话超时');
          }
          
          // 4. 激活智能体会话
          const agentChatIndex = this.$store.state.chatStore.chats.findIndex(c =>
            c.type === 'AGENT' && c.agentId === this.selectedAgent.agentId
          );
          this.$store.commit('activeChat', agentChatIndex);
          
          this.taskStatus = '正在执行任务...';
          
          // 5. 调用 executeAgentTask 执行任务
          const userInfo = this.$store.state.userStore.userInfo || {};
          const tokenKey = sessionStorage.getItem('tokenKey') || userInfo.tokenKey || localStorage.getItem('tokenKey');
          
          const result = await executeAgentTask({
            agentId: this.selectedAgent.agentId,
            agentName: this.selectedAgent.name,
            taskContent: taskContent,
            imContext: {
              userId: userInfo.id,
              sessionId: agentChat.targetId,
              sessionType: 'AGENT',
              tokenKey: tokenKey
            }
          });
          
          if (result.success) {
            console.log('[Index] 任务执行成功:', result);
            this.happySessionId = result.sessionId;
            this.taskStatus = '执行中';
            this.taskLoading = false;
            // 如果 iframe 已就绪，发送导航事件
            if (this.iframeReady && this.iframeBridge) {
              setTimeout(() => {
                console.log('[Index] 发送导航到会话事件:', this.happySessionId);
                this.iframeBridge.sendCustomEvent('NAVIGATE_TO_SESSION', {
                  sessionId: this.happySessionId,
                  agentId: this.selectedAgent?.agentId
                });
              }, 300);
            }
          } else {
            console.error('[Index] 任务执行失败:', result.error);
            this.taskStatus = '任务启动失败';
            this.taskLoading = false;
          }
        } catch (e) {
          console.error('启动智能体失败:', e);
          this.taskStatus = '启动失败';
          this.taskLoading = false;
          this.pendingTask = '';
        }
      } else {
        console.log('发送消息:', this.searchText);
        this.searchText = '';
      }
    },

    handleSelectAgent(agent) {
      // 检查是否已登录
      const isLoggedIn = this.$store.getters.isLoggedIn
      const hasToken = sessionStorage.getItem('accessToken')
      
      if (!isLoggedIn && !hasToken) {
        // 未登录，跳转到智能体落地页
        if (agent.agentId) {
          const baseUrl = window.location.origin + window.location.pathname
          window.open(`${baseUrl}#/agent/profile/a/${agent.agentId}`, '_blank')
        }
        return
      }
      
      // 已登录，正常选择智能体
      this.selectedAgent = agent;
      this.searchText = ''; // 清空搜索文本，进入任务输入模式
      // 更新 placeholder
      const currentCard = this.cardData.find(c => c.id === this.currentType);
      if (currentCard) {
        this.currentPlaceholder = this.agentPlaceholder || currentCard.placeholder;
      }
      // 延迟 500ms 后 focus 输入框
      setTimeout(() => {
        this.$refs.searchInput?.focus();
      }, 500);
    },

    toggleNetworkSearch() {
      this.networkSearchEnabled = !this.networkSearchEnabled;
    },

    handleLogoClick() {
      const isLoggedIn = this.$store.getters.isLoggedIn
      const hasToken = sessionStorage.getItem('accessToken')
      
      if (!isLoggedIn && !hasToken) {
        window.open('https://www.shadanai.com', '_blank');
      }
    },

    toggleOpenMeSearch() {
      if (!this.openMeConfig.url || !this.openMeConfig.apiKey) {
        this.showOpenMeConfig = true;
      } else {
        this.openMeSearchEnabled = !this.openMeSearchEnabled;
        if (this.openMeSearchEnabled) {
          // 切换到 OpenMe 卡片
          const knowledgeIndex = this.cardData.findIndex(c => c.id === 'knowledge');
          if (knowledgeIndex !== -1) {
            this.rotateToCard(knowledgeIndex);
          }
        }
      }
    },

    loadOpenMeConfig() {
      const saved = localStorage.getItem('openMeConfig');
      if (saved) {
        this.openMeConfig = JSON.parse(saved);
        this.openMeSearchEnabled = true;
      }
    },

    saveOpenMeConfig() {
      if (this.openMeConfig.url && this.openMeConfig.apiKey) {
        localStorage.setItem('openMeConfig', JSON.stringify(this.openMeConfig));
        this.openMeSearchEnabled = true;
        this.showOpenMeConfig = false;
      }
    },

    cancelOpenMeConfig() {
      this.showOpenMeConfig = false;
    },

    goToAgentSessions() {
      // 跳转到聊天页面并激活智能体会话面板
      this.$router.push({
        path: '/home/chat',
        query: { showAgentList: 'true' }
      });
    },

    closeTaskPanel() {
      this.showTaskPanel = false;
      this.taskLoading = false;
      this.taskStatus = '执行中';
      this.pendingTask = '';
      this.happySessionId = null;
      this.iframeReady = false;
      this.iframeBridge = null;
    },

    onTaskIframeLoad() {
      console.log('[Index] 任务面板 iframe onload 触发');
      this.initIframeBridge();
    },

    initIframeBridge() {
      const iframe = this.$refs.taskIframe;
      if (!iframe || this.iframeBridge) return;

      console.log('[Index] 初始化 iframeBridge');
      this.iframeBridge = new HappyIframeBridge({ allowedOrigins: ['*'] });
      this.iframeBridge.setIframe(iframe);

      // 监听 ready 事件
      this.iframeBridge.on('ready', () => {
        console.log('[Index] iframe 通信桥接已就绪');
        this.iframeReady = true;
        // 当前会话已激活，发送 INIT
        this.sendInitToIframe();
      });
    },

    sendInitToIframe() {
      if (!this.iframeBridge) return;

      const storeUserInfo = this.$store.state.userStore.userInfo;
      if (!storeUserInfo || !storeUserInfo.id) {
        console.warn('[Index] userInfo 无效，无法发送 INIT');
        return;
      }

      const tokenKey = sessionStorage.getItem('tokenKey') || storeUserInfo.tokenKey || localStorage.getItem('tokenKey');
      const accessToken = sessionStorage.getItem('accessToken') || storeUserInfo.accessToken || localStorage.getItem('accessToken');

      // 从 chatStore 获取当前激活的会话
      const chat = this.$store.state.chatStore.activeChat;
      const imSessionInfo = chat ? {
        sessionId: chat.id || chat.targetId,
        sessionType: chat.type,
        sessionName: chat.showName || chat.name || `智能体(${chat.targetId})`,
        targetId: chat.targetId,
        agentId: chat.agentId,
        agentName: chat.name
      } : null;

      this.iframeBridge.sendInit({
        id: storeUserInfo.id,
        userId: String(storeUserInfo.id),
        username: storeUserInfo.userName || storeUserInfo.username,
        nickName: storeUserInfo.nickName,
        avatar: storeUserInfo.headImage || storeUserInfo.avatar,
        tokenKey,
        accessToken
      }, {
        agentId: this.selectedAgent?.agentId,
        name: this.selectedAgent?.name
      }, imSessionInfo);

      // 如果有 happy 会话 ID，发送导航事件让 iframe 定位到该会话
      if (this.happySessionId) {
        setTimeout(() => {
          console.log('[Index] 发送导航到会话事件:', this.happySessionId);
          this.iframeBridge.sendCustomEvent('NAVIGATE_TO_SESSION', {
            sessionId: this.happySessionId,
            agentId: this.selectedAgent?.agentId
          });
        }, 500);
      }
    }
  }
};
</script>

<style lang="scss">
.ai-assistant-page {
  * {
    box-sizing: border-box;
  }

  min-height: 100vh;
  max-height: 100vh;
  background: #eff1fb;
  position: relative;
  overflow-y: auto;
  font-family: Microsoft YaHei, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  // 添加背景渐变装饰效果
  &::before,
  &::after {
    content: '';
    position: fixed;
    width: 600px;
    height: 600px;
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.3;
    pointer-events: none;
    z-index: 0;
  }

  &::before {
    background: radial-gradient(circle, rgba(155, 147, 240, 0.4) 0%, transparent 70%);
    top: -200px;
    left: -200px;
    animation: float1 20s ease-in-out infinite;
  }

  &::after {
    background: radial-gradient(circle, rgba(255, 155, 210, 0.4) 0%, transparent 70%);
    bottom: -250px;
    right: -250px;
    animation: float2 25s ease-in-out infinite;
  }

  @keyframes float1 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(50px, -50px) scale(1.1); }
  }

  @keyframes float2 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(-50px, 50px) scale(1.05); }
  }

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px 20px;
  position: relative;
  z-index: 1;
}

.header-section {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 30px;
  padding-top: 20px;
}

.header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    font-size: 32px;
    color: #1a1a1a;
    font-weight: 400;
    letter-spacing: 2px;
    margin: 0;
  }

  .title-decoration {
    width: 160px;
    height: 17px;
    margin-top: 8px;
  }
}

// 小玩偶在标题右侧
.mascot-avatar {
  position: absolute;
  right: 220px;
  top: 3px;
  width: 140px;
  height: 140px;
  z-index: 10;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
  }
}

// 搜索框容器
.search-box-wrapper {
  position: relative;
  max-width: 988px;
  margin: 0 auto 20px;
}

.search-box {
  background: #f5f5f5;
  border-radius: 24px;
  padding: 12px 16px;
  border: none;
  position: relative;
  transition: all 0.3s;
  z-index: 1;
  min-height: 160px;
  display: flex;
  align-items: flex-start;

  &:focus-within {
    background: #f0f0f0;
  }

  textarea {
    width: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    background: transparent;
    color: #333;
    font-weight: 400;
    resize: none;
    font-family: Microsoft YaHei, 'Avenir', Helvetica, Arial, sans-serif;
    line-height: 1.4;
    min-height: 24px;
    padding: 12px 0 0 0;
    vertical-align: top;
    
    &::placeholder {
      color: #999;
    }
  }
}

.search-toolbar {
  position: absolute;
  bottom: 8px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    pointer-events: auto;
  }

  .session-indicator {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    border-radius: 16px;
    transition: background 0.2s;
    color: #1890ff;

    &:hover {
      background: rgba(24, 144, 255, 0.1);
    }

    .session-badge {
      position: absolute;
      top: -2px;
      right: -2px;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      background: #ff4d4f;
      color: white;
      font-size: 10px;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .search-tag {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    background: #e8f4fd;
    color: #1890ff;
    border-radius: 16px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &.active {
      background: #1890ff;
      color: white;
    }

    &.inactive {
      background: #f5f5f5;
      color: #999;
    }

    .tag-close {
      margin-left: 4px;
      font-size: 16px;
      opacity: 0.7;
      
      &:hover {
        opacity: 1;
      }
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .toolbar-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 16px;
    transition: background 0.2s, opacity 0.2s;
    opacity: 0.6;
    color: #666;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      opacity: 1;
    }
  }

  .send-btn {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    border: none;
    background: #333;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    flex-shrink: 0;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.7;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
}

.connection-lines {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 5;

  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
  }

  .connection-path {
    fill: none;
    stroke: #E4E7ED;
    stroke-width: 2.5;
    stroke-linecap: round;
  }
}

.carousel-container {
  perspective: 1200px;
  height: 220px;
  position: relative;
  margin-bottom: 15px;
  overflow: visible;
}

.carousel {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

.card {
  position: absolute;
  width: 110px;
  height: 130px;
  left: 50%;
  top: 50%;
  margin-left: -55px;
  margin-top: -65px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1),
              opacity 0.5s ease,
              box-shadow 0.5s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  pointer-events: all;
  user-select: none;

  &.active {
    box-shadow: 0 8px 24px rgba(120, 100, 200, 0.2);
    border-color: rgba(120, 100, 200, 0.4);
  }
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.card-title {
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  text-align: center;
}

.card-desc {
  font-size: 9px;
  color: #999999;
  text-align: center;
  line-height: 1.2;
}

.content-display {
  margin-top: 30px;
  overflow: visible;
}

.content-divider {
  position: relative;
  height: 1px;
  margin: 0 auto 20px;
  max-width: 800px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    background: linear-gradient(to right,
      transparent 0%,
      #E4E7ED 10%,
      #E4E7ED 90%,
      transparent 100%);
  }

  &::after {
    content: '✦';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #667eea;
    font-size: 10px;
    background: rgba(255, 255, 255, 0.95);
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #EBEEF5;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  }
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .content-title {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .view-more {
    color: #667eea;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.2s;

    &:hover {
      color: #764ba2;
    }
  }
}

.usage-tip {
  background: linear-gradient(135deg, #f0f4ff 0%, #e8f4f8 100%);
  border: 1px solid #d4e4ed;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #5a6c7d;
}

.content-area {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.content-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #f0f0f0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
}

.item-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;
  flex-shrink: 0;
}

.item-details {
  flex: 1;
  min-width: 0;

  .item-title {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 4px;
  }

  .item-desc {
    font-size: 12px;
    color: #666;
    line-height: 1.4;
  }
}

.item-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;

  .tag {
    padding: 2px 8px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 11px;
    color: #666;
  }
}

.item-time {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
}

.file-list {
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  
  .file-item {
    display: grid;
    grid-template-columns: 40px 1fr 80px 120px 100px;
    align-items: center;
    padding: 8px 16px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: #f8f9fa;
    }
  }
  
  .file-icon {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: white;
    flex-shrink: 0;
    
    &.office-icon {
      font-family: Arial, sans-serif;
      font-weight: bold;
      font-size: 8px;
      
      &.word { background-color: #2B579A; }
      &.excel { background-color: #217346; }
      &.powerpoint { background-color: #ED6C02; }
      &.pdf { 
        background-color: #E50914;
        font-size: 6px;
      }
    }
  }
  
  .file-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    padding-left: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  
  .file-size {
    font-size: 12px;
    color: #666;
    text-align: right;
  }
  
  .file-source {
    font-size: 12px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .file-time {
    font-size: 12px;
    color: #999;
    text-align: right;
  }
}

.creator-list {
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  
  .creator-header {
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 2px solid #e5e5e5;
    font-weight: 600;
    color: #333;
  }
  
  .creator-item {
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
    cursor: pointer;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: #f8f9fa;
    }
  }
  
  .creator-col {
    font-size: 14px;
    color: #666;
  }
  
  .creator-info {
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }
  
  .creator-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
    font-weight: 600;
    flex-shrink: 0;
  }
  
  .creator-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .creator-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  
  .creator-bio {
    font-size: 13px;
    color: #666;
  }
  
  .creator-stats {
    display: flex;
    gap: 12px;
    font-size: 12px;
    color: #999;
  }
  
  .creator-followers {
    color: #666;
  }
  
  .creator-tags {
    color: #667eea;
  }
  
  .creator-agents {
    padding: 4px 0;
    
    .agents-container {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      padding: 8px;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e5e5e5;
    }
    
    .agent-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      padding: 6px 8px;
      background: white;
      border-radius: 6px;
      border: 1px solid #e5e5e5;
      transition: all 0.2s;
      cursor: pointer;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }
    
    .agent-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
    
    .agent-name {
      font-size: 11px;
      color: #666;
      white-space: nowrap;
    }
  }
}

.industry-list {
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  
  .industry-header {
    display: grid;
    grid-template-columns: 1.5fr 1fr 3fr;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 2px solid #e5e5e5;
    font-weight: 600;
    color: #333;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .industry-item {
    display: grid;
    grid-template-columns: 1.5fr 1fr 3fr;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
    cursor: pointer;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: #f8f9fa;
    }
  }
  
  .industry-col {
    font-size: 14px;
    color: #666;
  }
  
  .industry-name {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #333;
    font-weight: 500;
  }
  
  .industry-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
  }
  
  .creator-col {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .creator-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }
  
  .agents-col {
    padding: 4px 0;
  }
  
  .agents-container {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding: 8px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
  }
  
  .agent-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 6px 8px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    transition: all 0.2s;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }
  
  .agent-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
  
  .agent-name {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
  }
}

.page-footer {
  background: #1a1a1a;
  color: #fff;
  padding: 60px 20px 20px;
  margin-top: 80px;
  
  .footer-container {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    gap: 40px;
    margin-bottom: 40px;
  }
  
  .footer-brand {
    .footer-logo {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
      cursor: pointer;
      
      &:hover {
        opacity: 0.8;
      }
    }
    
    .footer-description {
      color: rgba(255, 255, 255, 0.7);
      line-height: 1.6;
      font-size: 14px;
      text-align: left;
    }
  }
  
  .footer-section {
    h4 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 16px;
      color: #fff;
      text-align: left;
    }
    
    .footer-links {
      list-style: none;
      padding: 0;
      margin: 0;
      
      li {
        margin-bottom: 12px;
        text-align: left;
        
        a {
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          font-size: 14px;
          transition: color 0.2s;
          
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
  
  .footer-bottom {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    
    p {
      margin: 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      
      a {
        color: rgba(255, 255, 255, 0.6);
        text-decoration: none;
        
        &:hover {
          color: #fff;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .footer-container {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0 0 20px 0;
    font-size: 18px;
    color: #1a1a1a;
  }

  .form-group {
    margin-bottom: 16px;

    label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }

    input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      font-size: 14px;
      transition: border-color 0.2s;

      &:focus {
        outline: none;
        border-color: #667eea;
      }
    }
  }

  .modal-actions {
    display: flex;
    gap: 12px;
    margin-top: 24px;

    button {
      flex: 1;
      padding: 10px;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.9;
      }
    }

    .btn-cancel {
      background: #f5f5f5;
      color: #666;
    }

    .btn-save {
      background: #667eea;
      color: white;
    }
  }
}

// 任务执行面板
.task-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.task-panel {
  width: 90%;
  max-width: 1200px;
  height: 80vh;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.task-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;

  .task-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .task-agent-name {
    font-size: 16px;
    font-weight: 600;
  }

  .task-status {
    font-size: 13px;
    padding: 4px 10px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
  }

  .close-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    font-size: 20px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

.task-panel-body {
  flex: 1;
  position: relative;
  background: #f5f5f5;
}

.task-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.task-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #666;
  font-size: 14px;

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #e0e0e0;
    border-top-color: #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

}
</style>
